import { createSelector } from 'reselect';

const getState = (state) => state?.bossUnavailable;
export const allLabels = (state) => state?.Labels;

export const getBossUnavailableProduct = createSelector(getState, (state) => {
  return state?.bossUnavailableProducts;
});

export const getBossUnavailableListId = createSelector(getState, (state) => {
  return state?.bossUnavailableListId;
});
export const getConvertedBossUnavailableList = createSelector(getState, (state) => {
  return state?.convertedBossUnavailableList;
});
export const getRemovedBossUnavailableList = createSelector(getState, (state) => {
  return state?.removedBossUnavailableList;
});
export const getBossUnavailableProductInList = createSelector(getState, (state) => {
  return state?.oosBossProductList;
});
